console.log("Hello from front js.")